import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Contact from './pages/Contact';
import Home from './pages/Home';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Layout from './components/Layout';
import InputLagCalculator from './pages/tools/inp';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Debug component to log route changes
const RouteLogger = () => {
  const location = useLocation();
  console.log('Current route:', location.pathname);
  return null;
};

const NotFound = () => {
  console.log('NotFound component rendered');
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1>Well, this is awkward</h1>
        <Link to="/" className="not-found-button">Return Home</Link>
      </div>
    </div>
  );
};

function App() {
  console.log('App component rendered');
  return (
    <Router>
      <ScrollToTop />
      <RouteLogger />
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <Home />
            </Layout>
          }
        />
        <Route
          path="/blog"
          element={
            <Layout>
              <Blog />
            </Layout>
          }
        />
        <Route
          path="/blog/:slug"
          element={
            <Layout>
              {console.log('BlogPost route matched')}
              <BlogPost />
            </Layout>
          }
        />
        <Route
          path="/contact"
          element={
            <Layout>
              <Contact />
            </Layout>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <Layout>
              <PrivacyPolicy />
            </Layout>
          }
        />
        <Route
          path="/tools/inp"
          element={
            <Layout>
              <InputLagCalculator />
            </Layout>
          }
        />
        <Route
          path="*"
          element={
            <Layout>
              <NotFound />
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
